import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { landingServices } from './Services/landing.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {  RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LandingComponent } from './landing.component';
import { LoaderModules } from '../loader/loader.module';
import { FooterSecondComponent } from './components/Virtusa/footer-second/footer-second.component';
import { SidebarIsdpComponent } from './components/sidebar-isdp/sidebar-isdp.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    LandingComponent,
    FooterSecondComponent,
    SidebarIsdpComponent
  ],
  imports: [
    CommonModule,
    LoaderModules,
    MatInputModule,
  MatMenuModule,
  MatFormFieldModule,
  MatDialogModule,
  RouterModule,
  MatRadioModule,
  MatPaginatorModule,
  FormsModule,
  ReactiveFormsModule,
  MatAutocompleteModule,
  MatSelectModule,
  MatAutocompleteModule,
  MatCheckboxModule,
  MatDialogModule,
  MatIconModule,
  MatTabsModule,
  MatProgressSpinnerModule,
  MatButtonModule
  ],
  providers:[landingServices],
  exports:[HeaderComponent,FooterComponent,SidebarComponent,FooterSecondComponent,SidebarIsdpComponent]
})
export class LandingModule { }

